import React, { useCallback, useMemo, useState } from 'react'
import classNames from 'classnames'
import styled from 'styled-components'

// 只提供最低限度的样式, 需要页面自行设置

const prefixCls = 'eufy-collapse'

const StyledContainer = styled.div`
  cursor: pointer;
`

const StyledTitle = styled.div`
  user-select: none;
`

const StyledContent = styled.div`
  display: none;
  ${StyledContainer}.active & {
    display: block;
  }
`

type CollapseProps = {
  title: string
  tagName?: keyof JSX.IntrinsicElements
}

const Collapse: React.FC<CollapseProps> = ({ tagName, title, children }) => {
  const [collapsed, setCollapsed] = useState(true)

  const handleClick = useCallback(() => {
    setCollapsed(!collapsed)
  }, [collapsed])

  return (
    <StyledContainer as={tagName} className={classNames(prefixCls, { active: !collapsed })}>
      <StyledTitle className={`${prefixCls}-title`} onClick={handleClick}>
        {title}
      </StyledTitle>
      <StyledContent className={`${prefixCls}-content`}>
        {children}
      </StyledContent>
    </StyledContainer>
  )
}

Collapse.defaultProps = {
  tagName: 'div',
}

export default Collapse
